import './bootstrap';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

import Vue from 'vue';
import CmsComponent from './components/cms.vue';

Vue.component('vueDropzone', () => import('vue2-dropzone'));
Vue.component('Datepicker', () => import('vuejs-datepicker'));
Vue.component('multiselect', () => import('vue-multiselect'));
Vue.component('editor', () => import('@tinymce/tinymce-vue'));

Vue.component('cms', CmsComponent);
Vue.component('student-form', () => import('./components/student-form.vue'));
Vue.component('view-student', () => import('./components/view-student.vue'));
Vue.component('file', () => import('./components/file.vue'));

window.Vue = Vue;

// Mount CMS components on data-cms-mount elements (Phase 3)
// CmsComponent is eagerly imported above so it is resolved synchronously
// before initCmsMounts runs — no async race condition.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCmsMounts);
} else {
  initCmsMounts();
}

function initCmsMounts() {
  const cmsMounts = document.querySelectorAll('[data-cms-mount]');
  cmsMounts.forEach((el) => {
    const name = el.getAttribute('data-name');
    const value = el.getAttribute('data-value');
    const editable = el.getAttribute('data-editable') === 'true';

    new Vue({
      el,
      render(h) {
        return h(CmsComponent, {
          props: { name, editable, value }
        });
      }
    });
  });
}




// WEBPACK FOOTER //
// ./resources/assets/js/app.js